'use client';

// Recovered from the IMAI v5 animation source; demo documents stay illustrative.
import * as React from 'react';
import { ShowcaseCopyContext, translateShowcaseNode } from '../translation';
import {
  ProductionArtifact,
  ProductionIllustrativeBadge,
} from './production-primitives';
import { J, $d } from './sell-market-animation';
import { FileTypeIcon } from './deliverable-files';
import { pm, mm, hm } from './sourcing-plan';
import { T } from './workflow-facts';
export const gm = [
  {
    title: 'Handle drop short',
    spec: 'Spec D 24.0 cm',
    found: 'Sample 22.5 cm',
    fix: 'Lengthen both handles 1.5 cm.',
    mark: {
      x: 0.5,
      y: 0.1,
      rx: 0.1,
      ry: 0.045,
    },
    badge: {
      x: 0.76,
      y: 0.06,
    },
    at: 700,
  },
  {
    title: 'Edge paint thin',
    spec: 'Even, burnished edge',
    found: 'Thin along the handle',
    fix: 'Re-coat and burnish the handle edges.',
    mark: {
      x: 0.385,
      y: 0.27,
      rx: 0.035,
      ry: 0.09,
    },
    badge: {
      x: 0.2,
      y: 0.2,
    },
    at: 1700,
  },
  {
    title: 'Tab stitching off-square',
    spec: 'Square to the top edge',
    found: 'Right tab tilts 2 mm',
    fix: 'Re-stitch the tab box square.',
    mark: {
      x: 0.626,
      y: 0.455,
      rx: 0.04,
      ry: 0.065,
    },
    badge: {
      x: 0.86,
      y: 0.36,
    },
    at: 2700,
  },
  {
    title: 'Body height over',
    spec: 'Spec B 30.0 cm',
    found: 'Sample 30.8 cm',
    fix: 'Trim the pattern 0.8 cm at the top edge.',
    mark: {
      x: 0.81,
      y: 0.65,
      rx: 0.03,
      ry: 0.22,
    },
    badge: {
      x: 0.93,
      y: 0.9,
    },
    at: 3700,
  },
];
export function Scene__m({ n: e, className: t = '' }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  return (
    <span
      className={`num grid size-5 shrink-0 place-items-center rounded-full bg-[var(--pd-red)] text-[11px] font-semibold text-white ${t}`}
    >
      {translateShowcaseNode(showcaseCopy, e)}
    </span>
  );
}
export function SampleRedlines({ t: e }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  return (
    <ProductionArtifact
      icon={'camera'}
      title={translateShowcaseNode(showcaseCopy, 'Proto 1 Redlines')}
      view={'Redline pack'}
      footer={
        <React.Fragment>
          <span
            {...J(e, 4700)}
            className={
              'pd-in text-ink-2 flex min-w-0 items-center gap-2 font-mono text-[12.5px]'
            }
          >
            <FileTypeIcon kind={'pdf'} className={'h-5 w-[18px]'} detail={!1} />
            <span className={'truncate'}>
              {translateShowcaseNode(showcaseCopy, 'tote-proto-1-redlines.pdf')}
            </span>
          </span>
          <span className={'text-ink-3 ml-auto hidden text-[13px] sm:inline'}>
            {translateShowcaseNode(showcaseCopy, 'One pack for the supplier')}
          </span>
        </React.Fragment>
      }
    >
      <div
        className={
          'grid gap-4 p-3 sm:p-5 md:grid-cols-[minmax(0,0.9fr)_minmax(0,1fr)] md:gap-6'
        }
      >
        <figure
          className={
            'relative m-0 self-start overflow-hidden rounded-[10px] bg-[var(--tint)] max-md:mx-auto max-md:w-full max-md:max-w-[340px]'
          }
        >
          <img
            src={pm.src}
            alt={translateShowcaseNode(
              showcaseCopy,
              `${pm.alt}, marked up with four redlines.`
            )}
            width={mm}
            height={hm}
            loading={'lazy'}
            decoding={'async'}
            className={'block h-auto w-full'}
          />
          <svg
            viewBox={`0 0 ${mm} ${hm}`}
            fill={'none'}
            stroke={'var(--pd-red)'}
            strokeWidth={'5'}
            strokeLinecap={'round'}
            aria-hidden={!0}
            className={'absolute inset-0 size-full'}
          >
            {translateShowcaseNode(
              showcaseCopy,
              gm.map((t) => {
                let n = t.mark.x * mm,
                  r = t.mark.y * hm,
                  i = t.badge.x * mm,
                  a = t.badge.y * hm;
                return (
                  <g key={t.title}>
                    <ellipse
                      cx={n}
                      cy={r}
                      rx={t.mark.rx * mm}
                      ry={t.mark.ry * hm}
                      pathLength={1}
                      data-on={String(e >= t.at)}
                      className={'pd-line'}
                      transform={`rotate(-4 ${n} ${r})`}
                    />
                    <path
                      d={`M${n + (i > n ? 1 : -1) * t.mark.rx * mm * 0.7} ${r + (a > r ? 1 : -1) * t.mark.ry * hm * 0.7}L${i} ${a}`}
                      pathLength={1}
                      data-on={String(e >= t.at + 350)}
                      className={'pd-line pd-line-fast'}
                      strokeWidth={'3.5'}
                    />
                  </g>
                );
              })
            )}
          </svg>
          {translateShowcaseNode(
            showcaseCopy,
            gm.map((t, n) => (
              <span
                key={t.title}
                data-on={String(e >= t.at + 650)}
                className={'pd-pop absolute'}
                style={{
                  left: `${t.badge.x * 100}%`,
                  top: `${t.badge.y * 100}%`,
                  translate: '-50% -50%',
                }}
              >
                <Scene__m
                  n={n + 1}
                  className={'shadow-[0_0_0_2px_rgb(255_255_255/0.9)]'}
                />
              </span>
            ))
          )}
          <span
            className={
              'pointer-events-none absolute inset-0 rounded-[inherit] shadow-[inset_0_0_0_1px_var(--img-outline)]'
            }
          />
        </figure>
        <div className={'flex min-w-0 flex-col'}>
          <div className={'flex items-center gap-2'}>
            <p className={'label'}>
              {translateShowcaseNode(showcaseCopy, 'Proto 1 vs. tech pack v2')}
            </p>
            <ProductionIllustrativeBadge className={'ml-auto'} />
          </div>
          <ol className={'mt-2 flex flex-col'}>
            {translateShowcaseNode(
              showcaseCopy,
              gm.map((t, n) => (
                <li
                  key={t.title}
                  {...J(e, t.at + 500)}
                  className={
                    'pd-in flex gap-3 border-b border-[var(--line)] py-3 last:border-0'
                  }
                >
                  <Scene__m n={n + 1} className={'mt-0.5'} />
                  <div className={'flex min-w-0 flex-col gap-0.5'}>
                    <span className={'text-ink text-[13.5px] font-medium'}>
                      {translateShowcaseNode(showcaseCopy, t.title)}
                    </span>
                    <span className={'num text-ink-3 text-[12.5px]'}>
                      {translateShowcaseNode(showcaseCopy, t.spec)}
                      {translateShowcaseNode(showcaseCopy, ' \xB7')}
                      {translateShowcaseNode(showcaseCopy, ' ')}
                      <span className={'text-[var(--pd-red)]'}>
                        {translateShowcaseNode(showcaseCopy, t.found)}
                      </span>
                    </span>
                    <span className={'text-ink-2 text-[13px]'}>
                      {translateShowcaseNode(showcaseCopy, t.fix)}
                    </span>
                  </div>
                </li>
              ))
            )}
          </ol>
        </div>
      </div>
    </ProductionArtifact>
  );
}
export const ym = T;
export const bm = [
  {
    value: ym.components,
    label: 'Components',
  },
  {
    value: ym.measurements,
    label: 'Measurements',
  },
  {
    value: ym.bomItems,
    label: 'BOM items',
  },
  {
    value: ym.operations,
    label: 'Operations',
    meta: `${ym.layers} layers · ${ym.joins} joins`,
  },
  {
    value: ym.qualityChecks,
    label: 'Quality checks',
  },
  {
    value: ym.engineeringReviews,
    label: 'Engineering reviews',
  },
];
export const xm = 1500;
export const Sm = 900;
export const Cm = xm + bm.length * Sm + 200;
export function TechpackMetadata({ t: e }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  return (
    <ul
      className={
        'grid grid-cols-3 gap-px overflow-hidden rounded-[10px] bg-[var(--line)] shadow-[0_0_0_1px_var(--line)] lg:grid-cols-6'
      }
    >
      {translateShowcaseNode(
        showcaseCopy,
        bm.map((t, n) => {
          let r = xm + n * Sm,
            i = Math.round(t.value * $d(e, r, 800));
          return (
            <li
              key={t.label}
              className={'bg-raised flex min-w-0 flex-col gap-0.5 px-3 py-2.5'}
            >
              <span
                className={`num font-mono text-[18px] leading-6 font-medium transition-colors duration-300 ${e >= r ? 'text-ink' : 'text-ink-4'}`}
              >
                {translateShowcaseNode(showcaseCopy, i)}
              </span>
              <span className={'text-ink-3 truncate text-[12px] leading-4'}>
                {translateShowcaseNode(showcaseCopy, t.label)}
              </span>
              {translateShowcaseNode(
                showcaseCopy,
                'meta' in t ? (
                  <span className={'text-ink-4 truncate text-[11px] leading-4'}>
                    {translateShowcaseNode(showcaseCopy, t.meta)}
                  </span>
                ) : null
              )}
            </li>
          );
        })
      )}
    </ul>
  );
}
